import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbMesureUnite } from '@/models/alodb/AloDbMesureUnite'
import { AloBaseArray } from '@/models/alo/AloBaseArray'



export default {  
  getMesureUnites(): AxiosPromise<AlrContainer<AloBaseArray<AloDbMesureUnite>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/mesureunite', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbMesureUnite>>(JSON.parse(data),AloDbMesureUnite.createAloDbMesureUniteArray)
      }]
    })
  },
  getMesureUnite(id:number):AxiosPromise<AlrContainer<AloDbMesureUnite>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/mesureunite/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbMesureUnite>(JSON.parse(data),AloDbMesureUnite.createAloDbMesureUniteWithDetail)
      }]
    })
  },
  saveMesureUnite(umbType:AloDbMesureUnite):AxiosPromise<AlrContainer<AloDbMesureUnite>> {
    if(umbType.MUT_ID && umbType.MUT_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/mesureunite/${umbType.MUT_ID}`, 
        method: 'PUT',
        data: umbType,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMesureUnite>(JSON.parse(data),AloDbMesureUnite.createAloDbMesureUniteWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/mesureunite`, 
        method: 'POST',
        data: umbType,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMesureUnite>(JSON.parse(data),AloDbMesureUnite.createAloDbMesureUniteWithDetail)
        }]
      })    
    }
    
  }
  
}